/**
 * Строка разбора — одна на чек, документ и операции из банка.
 *
 * Выглядит так же, как строка в «Операциях»: значок категории слева,
 * название, одна серая строка под ним, сумма справа. Человек уже знает эту
 * строку, и разбор не должен учить его новой: прежний вариант с плашкой
 * категории под названием и формой сопоставления сверху читался с трудом.
 *
 * Всё, что в строке решается, решается тапом по ней — в листе с теми же
 * полями, что у ручной записи. Что не так со строкой, сказано в ней самой,
 * а не внизу экрана.
 */
import type { ReactNode } from 'react';
import { Icon } from './icon.js';

const Tick = () => <Icon name="check" size={13} />;

export function ImportRow(p: {
  /** Значок категории; у позиции сохранённого чека его нет. */
  icon?: ReactNode;
  title: string;
  /** Серая строка: категория, счёт, количество. */
  sub?: ReactNode;
  /** В строке не хватает решения — подпись жёлтым. */
  warn?: boolean;
  amount: string;
  /** Строка видна, но записываться не будет. */
  muted?: boolean;
  check?: { on: boolean; label: string; onToggle: () => void; disabled?: boolean };
  onOpen?: () => void;
  openLabel?: string;
}) {
  return (
    <div className={`li imp${p.muted ? ' muted' : ''}`}>
      {p.check && (
        <button className={`impcheck${p.check.on ? ' on' : ''}`} role="checkbox" aria-checked={p.check.on}
          aria-label={p.check.label} disabled={p.check.disabled} onClick={p.check.onToggle}>
          {p.check.on && <Tick />}
        </button>
      )}
      <button className="impmain" onClick={p.onOpen} disabled={!p.onOpen}
        {...(p.openLabel ? { 'aria-label': p.openLabel } : {})}>
        {p.icon}
        <span className="nm">
          <b>{p.title}</b>
          {p.sub && <span className={p.warn ? 'warn' : undefined}>{p.sub}</span>}
        </span>
        <span className="am num">{p.amount}</span>
      </button>
    </div>
  );
}

/** Нижняя панель разбора: главное действие всегда под пальцем. */
export function ImportBar({ hint, children }: { hint?: string | null; children: ReactNode }) {
  return (
    <div className="impbar">
      {hint && <div className="imphint">{hint}</div>}
      {children}
    </div>
  );
}
